import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_2 = { class: "content mb-40px" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "flex align-items-center" }
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "flex mt-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      class: "employeeModal",
      showHeader: true,
      visible: $setup.showModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.showModal) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '60vw' },
      modal: true,
      contentClass: "wrap-ctn-modal-default"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-2xl font-bold" }, _toDisplayString('Tambah Dokumen Persyaratan'), -1)),
          _createElementVNode("div", null, [
            _createElementVNode("i", {
              class: "pi pi-times cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeDialog()))
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Form, {
            onSubmit: $setup.onSubmit,
            "validation-schema": $setup.schema,
            "initial-values": $setup.initialValues,
            class: "form-container"
          }, {
            default: _withCtx(({ errors, setFieldValue, values, meta }) => [
              _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  for: "documentType",
                  class: "label-text required"
                }, "Jenis Dokumen", -1)),
                _createVNode(_component_Field, { name: "DocumentType" }, {
                  default: _withCtx(({ handleChange, handleBlur, field }) => [
                    _createVNode(_component_SelectFetch, _mergeProps(field, {
                      modelValue: field.value,
                      inputId: `documentType`,
                      endpoint: "/talent/v1/DocumentTypes",
                      fieldLabel: (v) => v.name,
                      clearable: false,
                      searchFields: ['name'],
                      placeholder: `Pilih Jenis Dokumen`,
                      classname: 'custom-select'
                    }), null, 16, ["modelValue", "fieldLabel"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, _toDisplayString(errors.DocumentType), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                  for: "notes",
                  class: "label-text required"
                }, "Keterangan", -1)),
                _createVNode(_component_Field, { name: "Notes" }, {
                  default: _withCtx(({ handleChange, handleBlur, field }) => [
                    _createVNode(_component_Textarea, {
                      maxlength: 400,
                      id: "notes",
                      "aria-describedby": "notes-help",
                      autoResize: true,
                      rows: "3",
                      onChange: handleChange,
                      onBlur: handleBlur
                    }, null, 8, ["onChange", "onBlur"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, _toDisplayString(errors.Notes), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Field, { name: "IsRequired" }, {
                  default: _withCtx(({ handleChange, handleBlur, field }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Checkbox, {
                        modelValue: values.IsRequired,
                        "onUpdate:modelValue": ($event: any) => ((values.IsRequired) = $event),
                        inputId: "isRequired",
                        name: "IsRequired",
                        value: "true"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "isRequired",
                        class: "ml-2"
                      }, "WAJIB", -1))
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_9, _toDisplayString(errors.IsRequired), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  class: "btn-back mr-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onBack()))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Kembali")
                  ])),
                  _: 1,
                  __: [7]
                }),
                _createVNode(_component_Button, {
                  type: "submit",
                  class: "btn-primary mr-1",
                  disabled: (meta.valid && false)
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("Simpan Dokumen")
                  ])),
                  _: 2,
                  __: [8]
                }, 1032, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema", "initial-values"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}